import common from '../common/common'
import fetch from "../common/util"


export default {
    // 地址搜索
    searchAddress: function (queryStr) {
        return fetch.get(common.GetAppVar().A_CITYS_SEARCH, { "query": queryStr });
    },
    // 热门酒店
    searchHotHotel: function () {
        return fetch.get(common.GetAppVar().A_INDEX_HOTEL);
    },
    // 搜索酒店
    searchHotel: function (params) {
        return fetch.get(common.GetAppVar().A_HOTEL_SEARCH, params);
    },
    // 酒店收藏状态
    searchHotelColl: function (hotel_id) {
        return fetch.get(common.GetAppVar().A_HOTEL_COLLECTION, { "hotel_id": hotel_id });
    },
    // 酒店详情
    hotelDetail: function (hotel_id) {
        return fetch.get(common.GetAppVar().A_HOME_ROOMS_N, { "hotel_id": hotel_id });
    },
    // 酒店房源
    hotelRooms: function (params) {
        return fetch.get(common.GetAppVar().A_HOME_FIND_N, params);
    },
    // 房源详情
    searchRoomDetail: function (params) {
        return fetch.get(common.GetAppVar().A_ROOMS_DETAIL_N, params);
    },
    // 酒店最低价
    searchHotelPrice: function (hotel_id, indate, outdate) {
        return fetch.get(common.GetAppVar().A_HOTEL_PRICE, { "hotel_id": hotel_id, "checkin_date": indate, "checkout_date": outdate });
    },

}


// WEBPACK FOOTER //
// ./src/api/hotel.js